import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';

import { SwitchViews } from 'src/app/shared/helpers/enums';
import { ModalDirective } from 'src/app/shared/directives/modal.directive';
import { changeUserAnswer } from 'src/app/modules/users/store/user.actions';
import { ModalService } from 'src/app/core/services/modal.service';
import { changePitchAnswer } from 'src/app/modules/pitches/store/pitch.actions';
import { DetailViewQuestionsState, SimpleActionCreator } from 'src/app/shared/helpers/types';

@Component({
  selector: 'app-detail-view-questions',
  templateUrl: './detail-view-questions.component.html'
})
export class DetailViewQuestionsComponent {
  switchViews = SwitchViews;
  url = window.location.href;
  @Input() action: SimpleActionCreator<any>;
  @Input() author: boolean;
  @Input() modal: ModalDirective;
  @Input() state: Observable<DetailViewQuestionsState>;

  constructor(private modalService: ModalService) {}

  editAnswer(title: string, answer: string, id: string, userId: string): void {
    this.modalService.editAnswer(title, answer, id, this.modal, this.author ? changePitchAnswer : changeUserAnswer, userId);
  }
}
